import { styled } from '../../stitches.config.es.js';
var ApplePayContainer = styled("div", {
  ApplePayButtonStyle: "black",
  ApplePayButtonType: "plain",
  cursor: "pointer",
  display: "inline-block",
  height: 48,
  WebkitAppearance: "-apple-pay-button",
  width: "100%"
});
export { ApplePayContainer };